import React, { useState, useEffect } from 'react';
import Loader from '../../components/Loader';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AdminSettings = () => {
  const [settings, setSettings] = useState({
    whatsappNumber: '',
    email: '',
    companyName: '',
    tagline: ''
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const res = await fetch(`${API_URL}/api/admin/site-settings`);
      const data = await res.json();
      setSettings(data);
    } catch (err) {
      console.error('Error fetching settings:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSettings(prev => ({ ...prev, [name]: value }));
    setSaved(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      await fetch(`${API_URL}/api/admin/site-settings`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(settings)
      });
      setSaved(true);
    } catch (err) {
      console.error('Error saving settings:', err);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="admin-settings">
      <div className="admin-page-header">
        <h1>Site Settings</h1>
        <p>Configure your website settings</p>
      </div>

      <form onSubmit={handleSubmit} className="admin-settings-form">
        <div className="settings-card">
          <h3><i className="fa-solid fa-building"></i> Company Information</h3>
          
          <div className="form-group">
            <label>Company Name</label>
            <input
              type="text"
              name="companyName"
              value={settings.companyName}
              onChange={handleChange}
              placeholder="Elite Experiences"
            />
          </div>

          <div className="form-group">
            <label>Tagline</label>
            <input
              type="text"
              name="tagline"
              value={settings.tagline}
              onChange={handleChange}
              placeholder="Your journey begins with us"
            />
          </div>
        </div>

        <div className="settings-card">
          <h3><i className="fa-solid fa-address-book"></i> Contact Information</h3>
          
          <div className="form-group">
            <label>WhatsApp Number</label>
            <input
              type="text"
              name="whatsappNumber"
              value={settings.whatsappNumber}
              onChange={handleChange}
              placeholder="+919876543210"
            />
            <small>Include country code (e.g., +91 for India)</small>
          </div>

          <div className="form-group">
            <label>Email Address</label>
            <input
              type="email"
              name="email"
              value={settings.email}
              onChange={handleChange}
              placeholder="contact@example.com"
            />
          </div>
        </div>

        <div className="form-actions">
          <button type="submit" className="admin-btn primary" disabled={saving}>
            {saving ? 'Saving...' : (saved ? '✓ Saved' : 'Save Settings')}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AdminSettings;
